import * as types from 'store/selfServiceResults/selfServiceResultsTypes'

const initialState = []

const snackbarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROJECT_RESULTS_SUCCEEDED:
      return action.payload
    case types.FETCH_ALL_NECESSARY_PROJECT_INFO_SUCCEEDED:
    case types.NEW_PROJECT_CREATED:
      return initialState
    default:
      return state
  }
}

export default snackbarReducer
